import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { employeesAPI } from '../services/api';

export const useEmployees = () => {
  const queryClient = useQueryClient();

  // Get all employees
  const {
    data: employees = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['employees'],
    queryFn: employeesAPI.getAll,
  });

  // Create employee mutation
  const createEmployee = useMutation({
    mutationFn: employeesAPI.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['employees'] });
    },
  });

  // Update employee mutation
  const updateEmployee = useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) => 
      employeesAPI.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['employees'] });
    },
  });

  // Delete employee mutation
  const deleteEmployee = useMutation({
    mutationFn: employeesAPI.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['employees'] });
    },
  });

  return {
    employees,
    isLoading,
    error,
    refetch,
    createEmployee: createEmployee.mutate,
    updateEmployee: updateEmployee.mutate,
    deleteEmployee: deleteEmployee.mutate,
    isCreating: createEmployee.isPending,
    isUpdating: updateEmployee.isPending,
    isDeleting: deleteEmployee.isPending,
  };
};

export const useEmployee = (id: string) => {
  const {
    data: employee,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['employee', id],
    queryFn: () => employeesAPI.getById(id),
    enabled: !!id,
  });

  return {
    employee,
    isLoading,
    error,
    refetch,
  };
};
